// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
import { ImageCoverFragmentDoc } from '../imageCover.fragment.generated';
import { VideoFragmentDoc } from '../video.fragment.generated';
export const ComponentMainCoverFragmentDoc = gql`
    fragment componentMainCover on ComponentMainCover {
  content {
    ...contentComponentItem
  }
  height
  overlay
  contentWidth: width
  background {
    __typename
    ... on ComponentMainCoverBackgroundImage {
      backgroundImage {
        ...imageCover
      }
      mobileBackgroundImage {
        ...imageLarge
      }
    }
    ... on ComponentMainCoverBackgroundVideo {
      video {
        ...video
      }
      cover {
        ...imageCover
      }
      mobileCover {
        ...imageLarge
      }
    }
  }
}
    ${ContentComponentItemFragmentDoc}
${ImageCoverFragmentDoc}
${ImageLargeFragmentDoc}
${VideoFragmentDoc}`;